// extracted by mini-css-extract-plugin
module.exports = {"containerInner":"LandingMarquee_containerInner__289jC","containerOuter":"LandingMarquee_containerOuter__3LRmP","image":"LandingMarquee_image__3toH0"};